var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBottomShape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 110,
    viewBox: "0 0 100 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1410097620"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.0461 109.437H37.9341L100 6.447V0.000305176L34.0461 109.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M100 22.6824L47.4965 109.873H100V22.6824Z",
    fill: "#FF7236"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0.000473022 109.873H27.2584L63.7949 49.2468H36.537L0.000473022 109.873Z",
    fill: "#0B3742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M48.464 36.3379H61.7462L79.5469 6.79973H66.2647L48.464 36.3379Z",
    fill: "#FF7236"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomShape);
export default __webpack_public_path__ + "static/media/bottom-shape.adfc18842e0aa2e3b1d3d65ee04a58ec.svg";
export { ForwardRef as ReactComponent };